import RemoveCircle from 'assets/icons/RemoveCircle'
import { NavBar } from 'components/NavBar/NavBar'
import { setConfirmModal } from 'features/global/globalSlice'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
    Flex,
    GridItem,
    ItemsGrid,
    H1WithBack,
    PageFooter,
    PageWrapper,
} from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { FuelTypesModal } from './FuelTypesModal'
import { clearTypes, deleteFuelType, getFuelTypes } from 'features/fuelManagement/fuelManagementSlice'

export const FuelTypes = () => {
    const [modal, setModal] = useState({ open: false, value: null })
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const [params, setParams] = useState<any>(getParams({ location }))
    const { types } = useSelector((store: RootState) => store.fuelManagement)

    useQueryPagination({ fetchFunctions: [getFuelTypes], cleanUpFunctions: [clearTypes], params })

    const removeInvField = (id: number) => {
        dispatch(
            setConfirmModal({
                isOpen: true,
                onSave: async () => {
                    await dispatch(deleteFuelType(id))
                },
                setParams: {
                    type: ModalTypes.Delete,
                    f: setParams,
                    noItems: types.data.length < 2,
                },
                word: 'delete type',
            }),
        )
    }

    return (
        <>
            <PageWrapper>
                <NavBar defaultValue={params.q} input placeholder='Search Fuel Types...' setParams={setParams} />
                <Flex between mb='16' >
                    <H1WithBack title='Fuel Types' arrow onClick={() => navigate('/fuel/dashboard')} />
                    <Button variant='primary' onClick={() => setModal({ open: true, value: null })}>
                        Add Type
                    </Button>
                </Flex>
                {!types?.data?.length ? <NoItems title='Types' /> : <ItemsGrid columns={3} mt='1.5rem'>
                    {
                        types?.data?.map((item) => {
                            return (
                                <GridItem key={item.id}>
                                    <p onClick={() => setModal({ open: true, value: { id: item.id, name: item.name, standardCost: item.standardCost, description: item.description } })}>{item.name}</p>
                                    <Flex between center onClick={() => removeInvField(item.id)}>
                                        <RemoveCircle />
                                    </Flex>
                                </GridItem>
                            )
                        })}
                </ItemsGrid>}


            </PageWrapper>
            {modal.open &&
                <FuelTypesModal value={modal.value} closeModal={() => setModal({ value: null, open: false })} />
            }
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams)}
                    pageCount={Math.ceil(types.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
